module.exports = __webpack_public_path__ + "img/ErWerken.83bc9fe3.png";